
const INITIAL_STATE = {
    error: false,
    loading: false,
    data: {
        completed: null,
        file: null
    }
}

const AddMedias = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'PRODUCT_ADD_MEDIA_REQUEST':
            return { loading: true, error: false, data: { completed: false, file: action.payload } }
        case 'PRODUCT_ADD_MEDIA_ERROR':
            return { loading: false, error: true, data: { completed: "error", file: action.payload } };
        case 'PRODUCT_ADD_MEDIA_SUCCESS':
            return { loading: false, error: false, data: { completed: true, file: action.payload } };
        case 'PRODUCT_ADD_MEDIA_RESET':
            return { loading: false, error: false, data: [] };
        default:
            return state;
    }
}

export default AddMedias